<small
    *ngIf="required"
    class="required"
    [class.inverted]="inverted"
    [attr.aria-hidden]="ariaHidden"
> 
    (required)
</small>